"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _CCheckBox = _interopRequireDefault(require("./CCheckBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledLabel = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginLeft: theme.spacing(-1),
    fontSize: theme.typography.body2.fontSize
  };
});
const StyledRoot = (0, _styles.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  marginRight: -15
});

/**
 * チェックボックスヘッダ部品
 * @prop {node} [label] - ラベル
 * @prop {array} list - 一覧データのリスト
 * @prop {func} getId - 一覧データを一意に扱うためのIDを取得する関数 <br/>
 * シグネチャ:(list[index]:object):string
 * @prop {func} [checkLogic] - チェック状態のオブジェクトが真偽値でないときの判定ロジック <br/>
 * シグネチャ:(checkedListChild:object):bool
 * @prop {object} checkedList - チェック状態のオブジェクト、getIdの取得結果を属性名とし真偽値を持つ
 * @prop {object} [paging] - ページング情報
 * @prop {number} [paging.viewNum] - 表示件数の選択値
 * @prop {number} [paging.currentPage] - 現在ページ位置
 * @prop {func} changeCheckedAll - チェック状態変更関数 <br/>
 * シグネチャ:(checked:bool):void
 */
const CheckBoxHeader = props => {
  const {
    className,
    changeCheckedAll,
    label,
    list = [],
    checkedList = {},
    checkLogic = value => value,
    paging = {
      viewNum: list.length,
      currentPage: 0
    },
    getId
  } = props;
  const isCheckAll = () => {
    // 更新するデータ範囲を決定
    let rangeData = list.slice(paging.currentPage * paging.viewNum, paging.currentPage * paging.viewNum + paging.viewNum);
    return !rangeData.some(item => {
      return !checkLogic(checkedList[getId(item)]);
    });
  };
  return /*#__PURE__*/_react.default.createElement(StyledRoot, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledLabel, {
    component: "span",
    color: "text.secondary"
  }, label), /*#__PURE__*/_react.default.createElement(_CCheckBox.default, {
    color: "primary",
    checked: isCheckAll(),
    onChange: () => {
      changeCheckedAll(!isCheckAll());
    }
  }));
};
CheckBoxHeader.propTypes = {
  label: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  getId: _propTypes.default.func.isRequired,
  checkLogic: _propTypes.default.func,
  checkedList: _propTypes.default.object.isRequired,
  paging: _propTypes.default.shape({
    viewNum: _propTypes.default.number,
    currentPage: _propTypes.default.number
  }),
  changeCheckedAll: _propTypes.default.func.isRequired
};
var _default = exports.default = CheckBoxHeader;